// extracted by mini-css-extract-plugin
export default {"products":"jy-z","card":"ky-z","oosMessaging":"ly-z"};